import {TextField, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {handleUpdateOrderSubscription} from "../actions/ordersubscription";
import {validateField} from "../utils/helpers";
// Redux connected component for Contact Person form in BillingAddress.js
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription,
  }) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {
    // redux functions
    handleUpdateOrderSubscription,
  }
)((props) => {
  let i18n = props.i18n;
  const isLoading = props.isLoading;
  // State variables for form fields with default empty string values
  const [firstName, setFirstName] = useState(
    props.orderSubscription?.firstName || ""
  );
  const [lastName, setLastName] = useState(
    props.orderSubscription?.lastName || ""
  );
  const [email, setEmail] = useState(props.orderSubscription?.email || "");
  const [department, setDepartment] = useState(
    props.orderSubscription?.department || ""
  );
  const [telephoneNumber, setTelephoneNumber] = useState(
    props.orderSubscription?.telephoneNumber || ""
  );
  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    email: false,
  });
  useEffect(() => {
    props.handleUpdateOrderSubscription({
      firstName: firstName,
      lastName: lastName,
      email: email,
      department: department,
      telephoneNumber: telephoneNumber,
    });
  }, [firstName, lastName, email, department, telephoneNumber]);

  return (
    <div className="card-info">
      <Typography variant="h2">{i18n.contact_person}</Typography>
      <div className="contact-person">
        <div className="column">
          <div className="textField-row">
            <TextField
              required
              placeholder={i18n.firstName}
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
                setError(e.target.value === "");
              }}
              error={validateField(firstName)}
              helperText={
                validateField(firstName) ? "Vorname ist erforderlich" : ""
              }
              FormHelperTextProps={{
                className: "helper-text-margin",
              }}
            />
            <TextField
              required
              placeholder={i18n.lastName}
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                setError(e.target.value === "");
              }}
              error={validateField(lastName)}
              helperText={
                validateField(lastName) ? "Nachname ist erforderlich" : ""
              }
              FormHelperTextProps={{
                className: "helper-text-margin",
              }}
            />
          </div>
          <div className="textField-row">
            <TextField
              placeholder={i18n.department}
              value={department}
              onChange={(e) => {
                setDepartment(e.target.value);
              }}
            />
            <TextField
              placeholder={i18n.telephoneNumber}
              value={telephoneNumber}
              onChange={(e) => {
                setTelephoneNumber(e.target.value);
              }}
            />
          </div>
          <TextField
            required
            style={{width: "48%"}}
            placeholder={i18n.email}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError(e.target.value === "");
            }}
            error={validateField(email)}
            helperText={validateField(email) ? "Email ist erforderlich" : ""}
            FormHelperTextProps={{
              className: "helper-text-margin",
            }}
          />
        </div>
      </div>
      <p className="text">E-Mail wird auch für Admin-User verwendet</p>
    </div>
  );
});
